export const money = value => value == null || value === '' || !Number.isFinite(Number(value))
    ? 'No disponible' : Number(value).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
export const dateLabel = value => {
    if (!value) return 'Sin fecha';
    const date = new Date(value.length === 10 ? `${value}T12:00:00` : value);
    return Number.isNaN(date.getTime()) ? 'Sin fecha' : date.toLocaleDateString('es-ES');
};
export const caseStates = {
    borrador: 'Borrador', factura_solicitada: 'Factura solicitada', pendiente_lectura: 'Pendiente de lectura', pendiente_revision: 'Revisar datos',
    comparado: 'Comparativa calculada', tarifa_elegida: 'Tarifa elegida', propuesta_preparada: 'Propuesta preparada',
};
export const actorLabel = actor => actor?.name || 'No disponible';
export function summarizeCase(record) {
    const reviewed = record.reviewed_input || {};
    const pending = record.active_document_id && record.extraction?.document_id !== record.active_document_id;
    return { id: record.id, titulo: record.titulo, version: record.version, created_at: record.created_at, updated_at: record.updated_at,
        archived_at: record.archived_at, archived_by: record.archived_by,
        created_by: record.created_by, updated_by: record.updated_by, channel_id: record.channel_id, participated_by_me: record.participated_by_me,
        cups: reviewed.cups, tarifa_atr: reviewed.tarifa_atr,
        tiene_documento: Boolean(record.active_document_id || record.extraction || record.documents?.length),
        estado: pending ? 'pendiente_lectura' : record.proposal ? 'propuesta_preparada' : record.selected_offer ? 'tarifa_elegida'
            : record.comparison ? 'comparado' : Object.keys(reviewed).length || record.extraction ? 'pendiente_revision' : record.invoice_request ? 'factura_solicitada' : 'borrador',
        tarifa_elegida: record.selected_offer?.offer.nombre };
}
